import React, { useEffect } from "react";
import {
  Container,
  Content,
  MainTitle,
  Wrapper,
  Desc,
  Title,
} from "../LegalStyles";

export const Term = () => {
  return (
    <Wrapper>
      <Container>
        <Content>
          <MainTitle>Terms of Use</MainTitle>
          <Desc>PLEASE READ THESE TERMS OF USE BEFORE USING THE WEBSITE.</Desc>
          <Title>Acceptance of the Terms of Use</Title>
          <Desc>
            These terms of use are entered into by and between you and the
            BSCS ("BSCS", "we" or "us"). The following terms and
            conditions, together with any documents they expressly incorporate
            by reference (collectively, these "Terms of Use"), govern your
            access to and use of BSCS.finance, including any content,
            functionality and services offered on or through BSCS.finance,
            BSCS.substack.com <span >or any other website that belongs to</span> BSCS (together, the "Website").
          </Desc>
          <Desc>
            Please read the Terms of Use carefully before you start to use the
            website. By using the website or by clicking to accept or agree to
            the Terms of Use when this option is made available to you, you
            accept and agree to be bound and abide by these Terms of Use in
            addition to
            <ul>
              <li>
                our <span className="bold">Privacy Policy</span>, incorporated
                herein by reference;
              </li>
              <li>
                our <span className="bold">Cookie Policy</span>, incorporated
                herein by reference.
              </li>
            </ul>
            If you do not agree to these Terms of Use or the Privacy Policy, you
            must not access or use the Website. <br /><br />

            This end user agreement (the "Agreement") should be read by you (the "User" or "you") in its entirety prior to your use of BSCS service or products. Be aware that this Agreement constitutes a legally binding agreement between you and BSCS (referred to herein as "BSCS", "us" or "we") which owns and operates the website on the Internet and the Service at www.BSCS.com (the "Service"). You consent to adhering to all the terms set forth in this Agreement when/if you are provided with an “I Agree” button and clicking on it.
          </Desc>
          <Title>Who May Use the Website</Title>
          <Desc>
            This Website is offered and available to users who are 13 years of
            age or older. The Website is not intended for children under 13
            years of age. By using this Website, you represent and warrant that
            you (i) are 13 years of age or older, (ii) are not barred from using
            the Website under any applicable law, and (iii) are using the
            Website only for your own personal use. If you do not meet these
            requirements, you must not access or use the Website.
          </Desc>
          <Title>Changes to the Terms of Use</Title>
          <Desc>
            We may revise and update these{" "}
            <span className="bold">Terms of Use</span> from time to time at our
            sole discretion. All changes are effective immediately when we post
            them.
          </Desc>
          <Desc>
            Your continued use of the Website following the posting of the
            revised Terms of Use means that you accept and agree to the changes.
            You are expected to check this page frequently so you are aware of
            any changes, as they are binding on you.
          </Desc>
          <Title>Accessing the Website and Account Security</Title>
          <Desc>
            We reserve the right to withdraw or amend this Website and any
            service or material we provide on the Website, in our sole
            discretion without notice.
          </Desc>
          <Desc>
            We do not guarantee that our site or any content on it, will always
            be available or be interrupted. We will not be liable if for any
            reason all or any part of the Website is unavailable at any time or
            for any period. From time to time, we may restrict access to some
            parts of the Website, or the entire Website, to users.
          </Desc>
          <Desc>
            You are responsible for:
            <ul>
              <li>
                Making all arrangements necessary for you to have access to the
                Website.
              </li>
              <li>
                Ensuring that all persons who access the Website through your
                internet connection are aware of these Terms of Use and comply
                with them.
              </li>
            </ul>
            To access the Website or some of the resources it offers, you may be
            asked to provide certain registration details or other information.
            It is a condition of your use of the Website that all the
            information you provide on the Website is correct, current and
            complete. You agree that all information you provide to register
            using this Website or otherwise, including, but not limited to,
            using any interactive features on the Website, is governed by our
            <span className="bold"> Privacy Policy</span>, and you consent to
            all actions we take with respect to your information consistent with
            our <span className="bold">Privacy Policy</span>.
          </Desc>
          <Desc>
            You should use particular caution when inputting personal
            information onto the Website on a public or shared computer so that
            others are not able to view or record your personal information.
          </Desc>
          <Title>Intellectual Property Rights</Title>
          <Desc>
            The Website and its entire contents, features and functionality
            (including but not limited to all information, software, text,
            displays, images, video and audio, and the design, selection and
            arrangement thereof) are owned by BSCS, its licensors or other
            providers of such material and are protected by copyright,
            trademark, patent, trade secret and other intellectual property or
            proprietary rights laws.
          </Desc>
          <Desc>
            Unless otherwise marked: (a) all material, data, and information on
            the website, such as data files, text, music, audio files or other
            sounds, photographs, videos, or other images, but excluding any
            software or computer code (collectively, the “Non- Code Content”) is
            licensed under the Creative Commons Attribution 4.0 International
            License; and (b) all software or computer code (collectively, the
            “Code Content”) is licensed under the MIT License.
          </Desc>
          <Title>Trademarks</Title>
          <Desc>
            The BSCS name, the terms BSCS, BSCS Launchpad, the
            BSCS logo and all related names, logos, product and service
            names, designs and slogans are trademarks of the BSCS or its
            affiliates or licensors. You must not use such marks without the
            prior written permission of the BSCS. All other names, logos,
            product and service names, designs and slogans on this Website are
            the trademarks of their respective owners.
          </Desc>
          <Title>Prohibited Uses</Title>
          <Desc>
            You may use the Website only for lawful purposes and in accordance
            with these <span className="bold">Terms of Use</span>. You agree not
            to use the Website:
            <ul>
              <li>
                In any way that violates any applicable federal, state, local or
                international law or regulation (including, without limitation,
                any laws regarding the export of data or software to and from
                the US or other countries).
              </li>
              <li>
                For the purpose of exploiting, harming or attempting to exploit
                or harm minors in any way by exposing them to inappropriate
                content, asking for personally identifiable information or
                otherwise.
              </li>
              <li>
                To send, knowingly receive, upload, download, use or re-use any
                material which does not comply with these Terms of Use.
              </li>
              <li>
                To transmit, or procure the sending of, any advertising or
                promotional material without our prior written consent,
                including any "junk mail", "chain letter" or "spam" or any other
                similar solicitation.
              </li>
              <li>
                To impersonate or attempt to impersonate the BSCS, a
                BSCS employee, another user or any other person or entity
                (including, without limitation, by using e-mail addresses or
                screen names associated with any of the foregoing).
              </li>
              <li>
                To engage in any other conduct that restricts or inhibits
                anyone's use or enjoyment of the Website, or which, as
                determined by us, may harm the BSCS or users of the
                Website or expose them to liability.
              </li>
            </ul>
            Additionally, you agree not to:
            <ul>
              <li>
                Use the Website in any manner that could disable, overburden,
                damage, or impair the site or interfere with any other party's
                use of the Website, including their ability to engage in real
                time activities through the Website.
              </li>
              <li>
                Use any robot, spider or other automatic devices, process or
                means to access the website for any purpose, including
                monitoring or copying any of the material on the Website.
              </li>
              <li>
                Use any manual process to monitor or copy any of the material on
                the website or for any other unauthorized purpose without our
                prior written consent.
              </li>
              <li>
                Use any device, software or routine that interferes with the
                proper working of the Website.
              </li>
              <li>
                Introduce any viruses, trojan horses, worms, logic bombs or
                other material which is malicious or technologically harmful.
              </li>
              <li>
                Attempt to gain unauthorized access to, interfere with, damage
                or disrupt any parts of the Website, the server on which the
                Website is stored, or any server, computer or database connected
                to the Website.
              </li>
              <li>
                Attack the Website via a denial-of-service attack or a
                distributed denial-of-service attack.
              </li>
              <li>
                Otherwise attempt to interfere with the proper working of the
                Website.
              </li>
            </ul>
            Additionally, you confirm that you are not a Prohibited Person.
            <ul>
              <li>
                "Prohibited Person” shall mean any individual or legal entity that is (i) a national or resident of, or legal entity formed or incorporated within or subject to the laws of any United States embargoed or restricted country; (ii) solely with respect to the non-government sanctioned trading, mining, minting of digital assets or cryptocurrency, or support of the foregoing, a national or resident of, or legal entity formed or incorporated within, or subject to the laws of the People’s Republic of China; (iii) a national or resident of, or legal entity formed or incorporated within or subject to the laws of the Socialist Republic of Vietnam, the Republic of Cuba, Democratic People’s Republic of North Korea, Venezuela, Islamic Republic of Iran, Libya, Republic of South Sudan, Republic of Sudan, Syrian Arab Republic, the Crimea, or any other jurisdiction in which it is prohibited from using the Website (the ”Prohibited Jurisdictions”); (iv) included on, or affiliated with any Person on, the United States Commerce Department’s Denied Persons List, Entities List, or Unverified List; the U.S. Department of the Treasury’s Specially Designated Nationals and Blocked Persons List, Specially Designated Narcotics Traffickers or Specially Designated Terrorists, or the Annex to Executive Order No. 13224; the Department of State’s Debarred List; or UN Sanctions; (v) a Person with whom business transactions, including exports and re-exports, are restricted by a United States Governmental Authority, including each item listed in the foregoing clauses (i), (ii), (iii), (iv) and (v) and any updates or revisions thereto and any newly published rules therefore; or (vi) a subject or target of any other economic sanctions administered or enforced by the United Nations, the European Union, the United States of America, or the United Kingdom.
              </li>
              <li>
                Any attempt to circumvent the restrictions on usage by any Prohibited Person is a breach of this Term of Use. An attempt at circumvention includes, but not limited to, manipulating the information used by BSCS to identify your location and providing BSCS with false or misleading information regarding your location.
              </li>
              <li>
                Any and all monies (including cryptocurrencies) of a Prohibited Person on the Website are void, and can be confiscated or may be returned to the person at BSCS sole discretion.
              </li>
            </ul>
          </Desc>
          <Title>Reliance on Information Posted</Title>
          <Desc>
            The information presented on or through the Website is made
            available solely for general information purposes. We do not warrant
            the accuracy, completeness or usefulness of this information. Any
            reliance you place on such information is strictly at your own risk.
            We disclaim all liability and responsibility arising from any
            reliance placed on such materials by you or any other visitor to the
            Website, or by anyone who may be informed of any of its contents.
          </Desc>
          <Desc>
            This Website includes content provided by third parties, including
            materials provided by other users, bloggers and third-party
            licensors, syndicators, aggregators and/or reporting services. All
            statements and/or opinions expressed in these materials, and all
            articles and responses to questions and other content, other than
            the content provided by BSCS, are solely the opinions and the
            responsibility of the person or entity providing those materials.
            These materials do not necessarily reflect the opinion of
            BSCS. We are not responsible, or liable to you or any third
            party, for the content or accuracy of any materials provided by any
            third parties.
          </Desc>
          <Title>Changes to the Website</Title>
          <Desc>
            We may update the content on this Website from time to time, but its
            content is not necessarily complete or up-to-date. Any of the
            material on the Website may be out of date at any given time, and we
            are under no obligation to update such material.
          </Desc>
          <Title>Information About You and Your Visits to the Website</Title>
          <Desc>
            All information we collect on this Website is subject to our{" "}
            <span className="bold">Privacy Policy</span>. By using the Website,
            you consent to all actions taken by us with respect to your
            information in compliance with the{" "}
            <span className="bold">Privacy Policy</span>.
          </Desc>
          <Title>Linking to the Website and Social Media Features</Title>
          <Desc>
            You may link to our homepage, provided you do so in a way that is
            fair and legal and does not damage our reputation or take advantage
            of it, but you must not establish a link in such a way as to suggest
            any form of association, approval or endorsement on our part without
            our express written consent.
          </Desc>
          <Title>Links from the Website</Title>
          <Desc>
            If the Website contains links to other sites and resources provided
            by third parties, these links are provided for your convenience
            only. This includes links contained in advertisements, including
            banner advertisements and sponsored links. We have no control over
            the contents of those sites or resources and accept no
            responsibility for them or for any loss or damage that may arise
            from your use of them. If you decide to access any of the
            third-party websites linked to this Website, you do so entirely at
            your own risk and subject to the terms and conditions of use for
            such website. We reserve the right to withdraw linking permission
            without notice.
          </Desc>
          <Title>Disclaimer of Warranties</Title>
          <Desc>
            You understand that we cannot and do not guarantee or warrant that
            files available for downloading from the internet or the website
            will be free of viruses or other destructive code. You are
            responsible for implementing sufficient procedures and checkpoints
            to satisfy your particular requirements for anti-virus protection
            and accuracy of data input and output, and for maintaining a means
            external to our site for any reconstruction of any lost data. We
            will not be liable for any loss or damage caused by a distributed
            denial-of-service attack, viruses or other technologically harmful
            material that may infect your computer equipment, computer programs,
            data or other proprietary material due to your use of the website or
            any services or items obtained through the website or to your
            downloading of any material posted on it, or on any website linked
            to it.
          </Desc>
          <Desc>
            Your use of the website, its content and any services or items
            obtained through the website is at your own risk. The website, its
            content and any services or items obtained through the website are
            provided on an "as is" and "as available" basis, without any
            warranties of any kind, either express or implied. Neither the
            foundation nor any person associated with the foundation makes any
            warranty or representation with respect to the completeness,
            security, reliability, quality, accuracy or availability of the
            website. Without limiting the foregoing, neither the foundation nor
            anyone associated with the foundation represents or warrants that
            the website, its content or any services or items obtained through
            the website will be accurate, reliable, error-free or uninterrupted,
            that defects will be corrected, that our site or the server that
            makes it available are free of viruses or other harmful components
            or that the website or any services or items obtained through the
            website will otherwise meet your needs or expectations.
          </Desc>
          <Desc>
            Bscs hereby disclaims all warranties of any kind, whether
            express or implied, statutory or otherwise, including but not
            limited to any warranties of merchantability, non-infringement and
            fitness for particular purpose.
          </Desc>
          <Desc>
            Some jurisdictions do not allow exclusion of warranties or
            limitations on the duration of implied warranties, so the above
            disclaimer may not apply to you in their entirety, but will apply to
            the maximum extent permitted by applicable law.
          </Desc>
          <Title>Limitation on Liability</Title>
          <Desc>
            In no event will bscs, its affiliates or their licensors,
            service providers, employees, agents, officers or directors be
            liable for damages of any kind, under any legal theory, arising out
            of or in connection with your use, or inability to use, the website,
            any website linked to it, any content on the website or such other
            website or any services or items obtained through the website or
            such other website, including any direct, indirect, special,
            incidental, consequential or punitive damages, including but not
            limited to, personal injury, pain and suffering, emotional distress,
            loss of revenue, loss of profits, loss of business or anticipated
            savings, loss of use, loss of goodwill, loss of data, and whether
            caused by tort (including negligence), breach of contract or
            otherwise, even if foreseeable. The foregoing does not affect any
            liability which can not be excluded or limited under applicable law
            which may include fraud.
          </Desc>
          <Title>Indemnification</Title>
          <Desc>
            You agree to defend, indemnify and hold harmless BSCS, its
            affiliates, licensors and service providers, and its and their
            respective officers, directors, employees, contractors, agents,
            licensors, suppliers, successors and assigns from and against any
            claims, liabilities, damages, judgments, awards, losses, costs,
            expenses or fees (including reasonable attorneys' fees) arising out
            of or relating to your violation of these{" "}
            <span className="bold">Terms of Use</span> or your use of the
            Website, including, but not limited to, any use of the Website's
            content, services and products other than as expressly authorized in
            these <span className="bold">Terms of Use</span> or your use of any
            information obtained from the Website.
          </Desc>
          <Title>Waiver and Severability</Title>
          <Desc>
            No waiver of/by BSCS of any term or condition set forth in
            these <span className="bold">Terms of Use</span> shall be deemed a
            further or continuing waiver of such term or condition or a waiver
            of any other term or condition, and any failure of BSCS to
            assert a right or provision under these{" "}
            <span className="bold">Terms of Use</span> shall not constitute a
            waiver of such right or provision.
          </Desc>
          <Desc>
            If any provision of these <span className="bold">Terms of Use</span>{" "}
            is held by a court or other tribunal of competent jurisdiction to be
            invalid, illegal or unenforceable for any reason, such provision
            shall be eliminated or limited to the minimum extent such that the
            remaining provisions of the{" "}
            <span className="bold">Terms of Use</span> will continue in full
            force and effect.
          </Desc>
          <Title>Entire Agreement</Title>
          <Desc>
            The <span className="bold">Terms of Use</span>, our{" "}
            <span className="bold">Privacy Policy</span> and terms of conditions
            for the registration of events constitute the sole and entire
            agreement between you and the BSCS with respect to the website
            and supersede all prior and contemporaneous understandings,
            agreements, representations and warranties, both written and oral,
            with respect to the website.
          </Desc>
          <Title>Your Comments and Concerns</Title>
          <Desc>
            This website is operated by BSCS. All other feedback,
            comments, requests for technical support and other communications
            relating to the website should be directed to:
            business@bscs.finance
          </Desc>
        </Content>
      </Container>
    </Wrapper>
  );
};
